/**
 * EventGroupName
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import GroupName from '../GroupName';

// Selectors
import { makeSelectEventValue } from '../../services/events/selectors';

interface Props {
    groupId: string;
}

export class EventGroupName extends React.PureComponent<Props> {
    render() {
        const { groupId } = this.props;
        return <GroupName groupId={groupId} />;
    }
}

const mapStateToProps = createStructuredSelector({
    groupId: makeSelectEventValue('groupId')
});

export default connect(mapStateToProps)(EventGroupName);
